export const FLAG_GETTING_DRIVER_COMMISSIONS =
  'FLAG_GETTING_DRIVER_COMMISSIONS';
export const GET_DRIVER_COMMISSIONS = 'GET_DRIVER_COMMISSIONS';
export const CLEAR_DRIVER_COMMISSIONS = 'CLEAR_DRIVER_COMMISSIONS';
